var _defs, _circle, _g, _rect, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#65686b;stroke-width:0.75px;}.c{fill:#65686b;}.d{stroke:none;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 13,
    cy: 13,
    r: 13
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(5 8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0H16.413a0,0,0,0,1,0,0V9.632a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V0A0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.75.375H15.663a.375.375,0,0,1,.375.375V9.632a1.625,1.625,0,0,1-1.625,1.625H2A1.625,1.625,0,0,1,.375,9.632V.75A.375.375,0,0,1,.75.375Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 16.413,
    height: 2.39,
    transform: "translate(5 7.39)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-419.525 -841)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1.2,
    height: 2.39,
    transform: "translate(426.525 846)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1.2,
    height: 2.39,
    transform: "translate(437.187 846)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.262 10.48)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 4.679,
    height: 4.679,
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.d53e08cb38a1ad47e7aad151081b9d89.svg";
export { ForwardRef as ReactComponent };